// theme.js
import { createTheme } from "@mui/material/styles";

import "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    myCustomColor: {
      GreyColor: string;
      main: string;
      light: string;
      dark: string;
      link?: string;
      disabled?: string;
      heading?: string;
    };
  }
  interface PaletteOptions {
    myCustomColor?: {
      GreyColor: string;
      main: string;
      light: string;
      dark: string;
      link?: string;
      disabled?: string;
      heading?: string;
    };
  }
}
const theme = createTheme({
  palette: {
    myCustomColor: {
      GreyColor: "#97999B",
      main: "#123456",
      light: "#56789a",
      dark: "#2C3034",
      link: " #2977CC",
      disabled: "#757982",
      heading: "#060110",
    },
  },
  typography: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",

    h1: {
      fontSize: "34px",
      fontWeight: 700,
    },
    h3: {
      fontSize: "16px",
      fontWeight: 400,
    },
    h4: {
      fontSize: "16px",
      fontWeight: 500,
      textAlign: "start",
    },
    h5: {
      fontSize: "14px",
      fontWeight: 500,
    },
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "6px",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          background: "#FFFFFF",
          borderRadius: "8px",
          alignItems: "flex-start",
          outline: "none",
          "::placeholder": {
            color: "#97999B", // Replace with `theme.palette.myCustomColor.GreyColor` if defined
            fontWeight: "400",
            fontSize: "16px",
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          background: "#ffffff",
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "30px",
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          p: 3,
          margin: "auto",
          maxWidth: "220px",
          // background: antiquewhite;
          borderRadius: "8px",
          "&.Mui-selected": {
            backgroundColor: "red", // Use your preferred active background color
            color: "#000", // Optional: change text color
          },
        },
      },
    },

    MuiTableRow: {
      styleOverrides: {
        root: {
          color: "red",
        },
      },
    },
  },
});

export default theme;
